import { render, staticRenderFns } from "./ReportDesktopTaken.vue?vue&type=template&id=c9931684"
import script from "./ReportDesktopTaken.vue?vue&type=script&lang=js"
export * from "./ReportDesktopTaken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports